import Lists from './ListsPage';

export default Lists;
